import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 1000px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: hidden;
  background-color: white;
  margin-top: 16px;
`;

export const ButtonConfort = styled.button`
  margin-left: auto;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  color: inherit;
  padding: 0 2px;
`;

export const ContainerLoader = styled.div`
  width: 100%;
  height: 700px;
  background-color: ${colors.bg['soft-200']};
  opacity: 0.4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  p {
    opacity: 1;
  }
`;

export const BottomLayer = styled.div`
  position: absolute;
  bottom: -20px;
  left: 0;
  width: 100%;
  height: 80px;
  background-color: white;
  pointer-events: auto;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 4px;
  gap: 8px;
`;

export const ToolbarRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ButtonExport = styled.button`
  color: ${colors.brand.principal};
  border: 1px solid ${colors.brand.principal};
  border-radius: 4px;
  background-color: ${colors.White};
  padding: 0 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 33px;
  font-weight: 600;
  gap: 6px;
  &:hover {
    cursor: pointer;
    background-color: ${colors.Blue050};
    border: 1px solid transparent;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ButtonVerDetalhes = styled.button`
  color: ${colors.brand.principal};
  border: 1px solid ${colors.brand.principal};
  border-radius: 4px;
  background-color: ${colors.White};
  padding: 0 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 33px;
  font-weight: 600;
  gap: 6px;
  &:hover {
    cursor: pointer;
    background-color: ${colors.Blue050};
    border: 1px solid transparent;
  }
`;

export const FilterWarningBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background-color: #FFF8EC;
  border: 1px solid ${colors.LightOrange};
  border-radius: 6px;
  color: ${colors.Orange600};
  font-size: 13px;
  font-weight: 500;
`;
